<template>
    <div>
        <div class="modal fade" id="photo-template-image-selection-11" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Select Image Position</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" @click="closePhotoPositionModal">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-center">
                        <span class="imagePosition cursor-pointer" @click="selectImagePosition(0)">1</span>
                    </div>
                </div>
            </div>
        </div>
        <image-cropper-js ref="PhotoSectionImageCropper" v-if="showImageEditor"></image-cropper-js>
        <div class="p-4 template-photo-section-11" style="height: auto; min-height: 100vh;">
            <textarea v-if="photoTemplate11ResourceData.title" id="title" rows="3" class="w-full text-center text-black text-3xl photo-page-template-title bg-transparent" placeholder="Edit Title" @blur="savePhotoSection()">{{photoTemplate11ResourceData.title}}</textarea>
            <textarea v-else id="title" rows="3" class="w-full text-center text-black text-3xl photo-page-template-title bg-transparent" placeholder="Edit Title" @blur="savePhotoSection()">
            </textarea>
            <div style="height: 560px;overflow: hidden;border-radius: 15px;" class="pg-photo-template-11">
                <div v-if="image1" class="photo-page-template-11-photo-div">
                    <div class="photo-page-template-11-photo photo-page-template-11-photo-placeholder" :style="'background-image: url('+photoTemplate11ResourceData.image[0].url+');'">
<!--                        <img :src="photoTemplate11ResourceData.image[0].url" style="width:100%;height:100%;">-->
                    </div>
                    <span class="photo-page-template-11-photo-remove mb-1" @click="removeImage1()">Remove Image</span>
                    <span class="photo-page-template-11-photo-remove" @click="editImage(photoTemplate11ResourceData.image[0].url, 0)">Edit Image</span>
                </div>
                <file-pond
                    v-else
                    name="test"
                    ref="photoTemplate1Resource"
                    labelIdle="<div id='photo-page-template-image-1-id' class='cursor-pointer photo-page-template-11-photo-placeholder-label' style='background-image: url(https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/photo-placeholder.png);' </div>"
                    labelFileProcessing="Uploading"
                    labelFileProcessingComplete="Image Uploaded"
                    allow-multiple="false"
                    :server="photoTemplate1ResourceServer"
                    :onprocessfile="handleOnProcessResourceFile"
                    :onaddfilestart="handleOnAddFileStart"
                    allowDrop="true"
                    dropOnElement="true"
                    accepted-file-types="image/jpeg, image/png, image/jpg, image/webp"
                    stylePanelAspectRatio="1:1"
                />
            </div>
            <textarea v-if="photoTemplate11ResourceData.image[0].caption" id="caption1" rows="3" class="w-full text-center text-black photo-page-template-title bg-transparent" placeholder="Edit Caption" @blur="savePhotoSection()">{{photoTemplate11ResourceData.image[0].caption}}</textarea>
            <textarea v-else id="caption1" rows="3" class="w-full text-center text-black photo-page-template-title bg-transparent" placeholder="Edit Caption" @blur="savePhotoSection()">
            </textarea>
        </div>
        <div class="proposal-edited-image-save">
            <img :src="proposal.proposal_loader" />
            <h1 class="align-center">Saving edited image. Please wait.</h1>
        </div>
    </div>
</template>
<script>
    import vueFilePond from 'vue-filepond';
    import 'filepond/dist/filepond.min.css';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import axios from "axios";
    import ImageCropperJs from "../../settings/image/image-cropper-js.vue";
    const FilePond = vueFilePond(FilePondPluginFileValidateType);
    let token = document.head.querySelector('meta[name="csrf-token"]');
    export default {
        components: {ImageCropperJs},
        props: ['section', 'proposal'],
        data(){
            return {
                photoTemplate1ResourceServer: {
                    revert: (uniqueFileId, load, error) => {
                        let file = JSON.parse(uniqueFileId).resource;
                        this.revertedResources.push(file.token);
                        axios.delete(route('api.resource-files.destroy', {resourceFile: file.token}))
                            .catch((err) => error(err.response.message));
                        load();
                    },
                    process: (fieldName, file, metadata, load, error, progress) => {
                        const formData = new FormData();
                        // if (this.section.company) formData.append('company_id', this.section.company.id);
                        if (this.proposal.project_id) formData.append('project_id', this.proposal.project_id);
                        if (2) formData.append('directory_id', 2);
                        formData.append(fieldName, file, file.name);

                        const request = new XMLHttpRequest();
                        request.open('POST', '/api/proposal-resource-files');
                        request.setRequestHeader('X-CSRF-TOKEN', token.content);

                        request.upload.onprogress = (e) => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        };
                        request.onload = function () {
                            if (request.status >= 200 && request.status < 300) {
                                load(request.responseText);
                            } else {
                                error('oh no');
                            }
                        };

                        request.send(formData);

                        // request.response = function (){
                        //     //---------------------
                        // }
                    }
                },
                image1: false,
                photoTemplate11ResourceData: {
                    'title': null,
                    'image': [
                        {
                            'url': null,
                            'caption':''
                        }
                    ]
                },
                s3Path: '',
                tempImageObj: null,
                tempPosition: null,
                showImageEditor: false,
                checkForImage: true,
                checkImageArray:[]
            }
        },
        methods: {
            handleOnProcessResourceFile(error, resourceFile) {
                let response = JSON.parse(resourceFile.serverId);
                this.$refs.photoTemplate1Resource.removeFile();
                this.image1 = true;
                this.s3Path = response.resource.s3_base_path;
                this.photoTemplate11ResourceData.image[0].url = response.resource.url;
                this.showImageEditor = true;
                this.tempPosition = 0;
                this.$nextTick(() => {
                    Bus.$emit('emitImageForEditingToFileRobot', {img: response.resource.url, cropRatio: 1});
                });
                $('.filepond--drop-label').show();
                Bus.$emit('fetchResourcesFromPhotoTemplate', true);
            },
            handleOnAddFileStart() {
                $('.filepond--drop-label').hide();
            },
            async uploadFile() {
                let files = this.$refs.responsiveFileInput.files;
                if (files) {
                    let i = 0;
                    for (i; i < files.length; i++) {
                        const formData = new FormData();

                        // if (this.section.company) formData.append('company_id', this.section.company.id);
                        if (this.proposal.project_id) formData.append('project_id', this.proposal.project_id);
                        if (2)  formData.append('directory_id', 2)
                        formData.append('test', files[i]);
                        await axios.post('/api/resource-files', formData).catch(err => {
                            window.Swal.fire({
                                title: "An error occurred!",
                                text: "The file could not be uploaded!",
                                buttons: true,
                            });
                        });
                    }
                    window.location.reload();
                }
            },
            removeImage1(){
                this.image1 = false;
                this.photoTemplate11ResourceData.image[0].url = null;
            },
            closePhotoPositionModal(){
                this.tempImageObj = null;
                $('#photo-template-image-selection-11').modal('hide');
            },
            selectImagePosition(position){
                this.s3Path = this.tempImageObj.s3_base_path
                this.photoTemplate11ResourceData.image[position].url = this.tempImageObj.url;
                this.image1 = true;
                $('#photo-template-image-selection-11').modal('hide');
                this.tempPosition = 0;
                this.showImageEditor = true;
                this.$nextTick(() => {
                    Bus.$emit('emitImageForEditingToFileRobot', {img: this.tempImageObj.url, cropRatio: 1});
                });
                this.savePhotoSection();
            },
            savePhotoSection(){
                this.photoTemplate11ResourceData.title = document.getElementById('title').value;
                this.photoTemplate11ResourceData.image[0].caption = document.getElementById('caption1').value;
                axios.post(route('proposal.save-photo-page'), {photoTemplate1ResourceData: this.photoTemplate11ResourceData, section: this.section}).then((response) => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                });
            },
            getSectionLatestData(){
                axios.post(route('proposal.get-photo-page'), {section: this.section}).then((response) => {
                    let data = response.data.section.photo_page_data;
                    if(data){
                        let pageData = JSON.parse(data);
                        this.photoTemplate11ResourceData.title = (pageData.title)? pageData.title.trim():null;
                        pageData.image.forEach((item, index) => {
                            if(item.url){
                                this.photoTemplate11ResourceData.image[index].url = item.url;
                                this.photoTemplate11ResourceData.image[index].caption = item.caption;
                                this.image1 = true;
                            }
                        });
                    }
                });
            },
            storeCroppedImage(imageData){
                this.showImageEditor = false;
                $('#cropper-js-image-modal').modal('hide');
                $('.proposal-edited-image-save').show();
                axios.post(route('api.proposal-resource-cropped-files.store'), {imageData: imageData, company_id: null, project_id: this.proposal.project_id}).then((response) => {
                    Bus.$emit('closeEmitImageForEditingToFileRobot', true);
                    this.photoTemplate11ResourceData.image[this.tempPosition].url = response.data.resource.url;
                    $('.proposal-edited-image-save').hide();
                    Bus.$emit('fetchResourcesFromPhotoTemplate', true);
                });
                this.savePhotoSection();
            },
            close() {
                this.$destroy();
                this.$el.parentNode.removeChild(this.$el);
            },
            editImage(imageUrl, index){
                this.tempPosition = index;
                this.showImageEditor = true;
                this.$nextTick(() => {
                    Bus.$emit('emitImageForEditingToFileRobot', {img: imageUrl, cropRatio: 1});
                });
            }
        },
        mounted() {
            Bus.$on('fetchPhotoData', data => {
                this.getSectionLatestData();
            });

            Bus.$on('emitPhotoForPhotoPage', data => {
                this.tempImageObj = data;
                this.checkImageArray = [];
                this.checkForImage = true;
                this.photoTemplate11ResourceData.image.forEach(image => {
                    this.checkImageArray.push(image.url)
                })

                this.$nextTick(() => {
                    if(this.checkImageArray.findIndex((obj) => obj === null || obj === '') == -1){
                        $('#photo-template-image-selection-11').modal('show');
                    }else{
                        this.photoTemplate11ResourceData.image.forEach((item, index) => {
                            if(this.checkForImage){
                                if(item.url == null || item.url == ''){
                                    this.image1 = true;
                                    item.url = this.tempImageObj.url
                                    this.savePhotoSection();
                                    this.checkForImage = false;
                                }
                            }
                        });
                    }
                });
            });

            Bus.$on('savePhotoSectionBtn-'+this.section.id, data => {
                this.savePhotoSection();
            });

            if(this.section.photo_page_data){
                this.photoTemplate11ResourceData.title = (this.section.photo_page_data.title)? this.section.photo_page_data.title.trim():null;
                this.photoTemplate11ResourceData.image[0].url = this.section.photo_page_data.image[0].url;
                this.photoTemplate11ResourceData.image[0].caption = this.section.photo_page_data.image[0].caption;
                this.image1 = true;
            }

            Bus.$on('closePhotoSectionComponent', data => {
                this.close();
            });

        },
        created() {

        }
    }
</script>
<style>
    .template-photo-section-11 .photo-page-template-title::-webkit-input-placeholder,
    .template-photo-section-11 .photo-page-template-title::-moz-placeholder,
    .template-photo-section-11 .photo-page-template-title:-ms-input-placeholder,
    .template-photo-section-11 .photo-page-template-title:-moz-placeholder {
        color: #22292f;
    }
    .template-photo-section-11 .photo-page-template-11-photo-placeholder {
        max-width: 550px;
        height: 550px;
        margin: 0 auto;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    .template-photo-section-11 .photo-page-template-11-photo-placeholder-label {
        width: 550px;
        height: 550px;
        margin: 0 auto;
        background-size: cover;
    }
    .template-photo-section-11 .pg-photo-template-11 .filepond--drop-label{
        height: 75vh !important;
        background: white !important;
    }
    .template-photo-section-11 .photo-page-template-11-photo-remove{
        width: 130px;
        display: block;
        text-align: center;
        position: relative;
        top: -50vh;
        left: 43%;
        background: #01b1af;
        border-radius: 5px;
        color: #fff;
        padding: 10px;
        cursor: pointer;
        display: none
    }
    .template-photo-section-11 .photo-page-template-11-photo-div:hover > .photo-page-template-11-photo{
        opacity: 0.3;
    }
    .template-photo-section-11 .photo-page-template-11-photo-div:hover >  .photo-page-template-11-photo-remove,
    .template-photo-section-11 .photo-page-template-11-photo-remove:hover{
        display: block;
    }
    span.imagePosition {
        background: #158a89;
        width: 33px;
        display: inline-block;
        color: white;
        border-radius: 2px;
        font-size: 20px;
        margin: 0 auto;
        text-align: center;
    }

    .pg-photo-template-11 .filepond--root{
        height: 553px !important;
        overflow: hidden;
    }

    .pg-photo-template-11 .filepond--image-preview-wrapper {
        height: 560px;
    }
</style>
